import { ROLE_SI_ADMIN, ROLE_PUBLICADOR } from '@/contexts/AuthContext';
import type { SiPortalAccessContext, SiPortalTab } from './siPortal.types';

export const SI_PORTAL_BASE_PATH = '/si';

export const SI_PORTAL_TITLE = 'Portal do SI';
export const SI_PORTAL_SUBTITLE = 'Informativos, documentos, acessos e equipamentos.';

/** Mesmo gate de hoje do módulo (`isSI` na lista de solicitações, guarda de Ativos e do
 * drawer de Configurações) — só `si_admin`; `si_rh` vê as abas de todos. */
export const SI_PORTAL_ROLES = {
  si: [ROLE_SI_ADMIN],
  /** Aba Publicações: "Publicar no Portal" (posts e documentos) e Administrar SI (só documentos). */
  publicacao: [ROLE_PUBLICADOR, ROLE_SI_ADMIN],
};

/** A ordem das abas é a ordem da lista. A 1ª é sempre visível (`/si` redireciona pra ela). */
export const SI_PORTAL_TABS: readonly SiPortalTab[] = [
  { id: 'inicio', label: 'Início', path: 'inicio', access: { kind: 'everyone' } },
  { id: 'documentos', label: 'Documentos', path: 'documentos', access: { kind: 'everyone' } },
  // Guardiões dos Dados (treinamento gamificado) — em teste: só o SI entra; o resto vê "Em breve".
  // Pra liberar: tirar `liberadoSoPara` (e GUARDIOES_LIBERADO_SO_PARA, que esconde o selo).
  {
    id: 'guardioes',
    label: 'Guardiões',
    path: 'guardioes',
    access: { kind: 'everyone' },
    liberadoSoPara: [ROLE_SI_ADMIN],
    icone: '🛡️',
  },
  { id: 'solicitacoes', label: 'Solicitações', path: 'solicitacoes', access: { kind: 'everyone' } },
  { id: 'controle', label: 'Controle de Solicitações', path: 'controle', access: { kind: 'roles', roles: SI_PORTAL_ROLES.si } },
  { id: 'dashboard', label: 'Dashboard', path: 'dashboard', access: { kind: 'roles', roles: SI_PORTAL_ROLES.si } },
  { id: 'ativos', label: 'Ativos', path: 'ativos', access: { kind: 'roles', roles: SI_PORTAL_ROLES.si } },
  { id: 'publicacoes', label: 'Publicações', path: 'publicacoes', access: { kind: 'roles', roles: SI_PORTAL_ROLES.publicacao } },
];

export function podeAcessarAbaSiPortal(tab: SiPortalTab, context: SiPortalAccessContext): boolean {
  const { access } = tab;
  if (access.kind === 'everyone') return true;
  return access.roles.some((role) => context.hasRole(role));
}

/** A pílula está "Em breve" pra esta pessoa (em teste e ela não está entre os liberados)? */
export function abaEmBreve(tab: SiPortalTab, context: SiPortalAccessContext): boolean {
  return Boolean(tab.liberadoSoPara) && !tab.liberadoSoPara!.some((role) => context.hasRole(role));
}

export function getVisibleSiPortalTabs(
  tabs: readonly SiPortalTab[],
  context: SiPortalAccessContext
): SiPortalTab[] {
  return tabs.filter((tab) => podeAcessarAbaSiPortal(tab, context));
}

export function getSiPortalTabHref(tab: SiPortalTab): string {
  return `${SI_PORTAL_BASE_PATH}/${tab.path}`;
}
